import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import NavContext from "../../context/nav/navContext";
const Navbar = props => {
  const navContext = useContext(NavContext);

  const onClick = () => {
    if (window.innerWidth < 800) {
      navContext.removeNavbar();
      navContext.getContent();
    }
  };
  return (
    <div className="navbar-container">
      <NavLink onClick={onClick} className="navlink" to="/">
        <ul className="active">
          Özhan YILDIZ
          <p>DEVELOPER,ENGİNEER</p>
        </ul>
      </NavLink>
      <ul>
        <NavLink onClick={onClick} className="navlink" to="/blog">
          My Posts & Portfolio
        </NavLink>
      </ul>
      <ul>
        <NavLink onClick={onClick} className="navlink" to="/about">
          About{" "}
        </NavLink>
      </ul>
      <ul className="finish">
        <NavLink onClick={onClick} className="navlink" to="/concerts">
          Concerts Records(.wav)
        </NavLink>
      </ul>
      <ul className="finish">
        <NavLink onClick={onClick} className="navlink" to="/contacts">
          Contact
        </NavLink>
      </ul>
    </div>
  );
};

export default Navbar;
